<template>
    <div class="animated fadeIn">

        <Request
                ref="requestBinderTableOfContent"
                method="GET"
                :onRequestSuccess="onRequestSuccess"
                root="/binder/table-of-content">
            <slot slot="body">
                <b-row>
                    <b-col lg="7" md="6">
                        <div v-show="dataBinderIndex == false">

                            <DynamicCardList
                                    key="dynamicCardListBinderIndex"
                                    ref="dynamicCardListBinderIndex"
                                    @onRetrieve="binderIndexOnRetrieveList"
                                    :caption="Core.Definition.getDefinition('Indexes')"
                                    :actions="dataDynamicCardListBinderIndex.actions"
                                    :searchFormStructure="dataDynamicCardListBinderIndex.searchFormStructure"
                                    :columns="dataDynamicCardListBinderIndex.columns"
                                    root="/binder-index/list">
                                <slot slot="cardTableHeaderActions">
                                    <b-link @click="binderIndexOnClickAdd" href="#" class="card-header-action btn-setting">
                                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Nouvel index')}}
                                    </b-link>

                                    <b-link :title="Core.Definition.getDefinition('Dupliquer vers')" @click="binderIndexOnClickDuplicate" class="btn-setting card-header-action ml-2"><i class="fa fa-files-o"></i></b-link>
                                    <b-link :title="Core.Definition.getDefinition('Déplacer vers')" @click="binderIndexOnClickMove" class="btn-setting card-header-action ml-2"><i class="fa fa-reply"></i></b-link>
                                    <b-link :title="Core.Definition.getDefinition('Supprimer')" @click="binderIndexesOnClickTrash" class="btn-setting card-header-action ml-2"><i class="fa fa-trash"></i></b-link>
                                </slot>
                            </DynamicCardList>
                        </div>
                        <div v-show="dataBinderIndex != false && Core.Validation.isId(dataBinderIndex.id)">
                            <div class="d-flex justify-content-between">
                                <b-button @click="binderFormOnClickBack" class="btn btn-light"><i class="fa fa-chevron-left"></i>&nbsp;{{dataBinderIndex.title}}</b-button>
                            </div>

                            <DynamicCardList
                                    v-if="Core.Validation.isId(dataBinderIndex.id)"
                                    key="dynamicCardListBinderForm"
                                    ref="dynamicCardListBinderForm"
                                    class="mt-2"
                                    @onRetrieve="binderFormOnRetrieveList"
                                    :caption="Core.Definition.getDefinition('Formulaires')"
                                    :actions="dataDynamicCardListBinderForm.actions"
                                    :searchFormStructure="dataDynamicCardListBinderForm.searchFormStructure"
                                    :columns="dataDynamicCardListBinderForm.columns"
                                    root="/binder-form/list">
                                <slot slot="cardTableHeaderActions">
                                    <b-link @click="binderFormOnClickAdd"  href="#" class="card-header-action btn-setting">
                                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Nouveau formulaire')}}
                                    </b-link>
                                    <b-link :title="Core.Definition.getDefinition('Dupliquer vers')" @click="binderFormOnClickDuplicate" class="btn-setting card-header-action ml-2"><i class="fa fa-files-o"></i></b-link>
                                    <b-link :title="Core.Definition.getDefinition('Déplacer vers')" @click="binderFormOnClickMove" class="btn-setting card-header-action ml-2"><i class="fa fa-reply"></i></b-link>
                                    <b-link :title="Core.Definition.getDefinition('Supprimer')" @click="binderFormsOnClickTrash" class="btn-setting card-header-action ml-2"><i class="fa fa-trash"></i></b-link>

                                </slot>
                            </DynamicCardList>
                        </div>
                        <ModalBinderIndex
                                ref="modalBinderIndex"
                                @onSaveSuccess="binderIndexOnSaveSuccess">
                        </ModalBinderIndex>
                        <ModalBinderForm
                                ref="modalBinderForm"
                                @onSaveSuccess="binderFormOnSaveSuccess">
                        </ModalBinderForm>
                        <ModalBinderAudit
                                ref="modalBinderAudit"
                                @onSaveSuccess="binderAuditOnSaveSuccess">
                        </ModalBinderAudit>
                    </b-col>
                    <b-col>
                        <DynamicCardList
                                :retrieveOnMount="false"
                                :caption="Core.Definition.getDefinition('Registre des modifications')"
                                key="dynamicCardListBinderAudit"
                                ref="dynamicCardListBinderAudit"
                                :searchFormStructure="dataDynamicCardListBinderAudit.searchFormStructure"
                                :columns="dataDynamicCardListBinderAudit.columns"
                                :actions="dataDynamicCardListBinderAudit.actions"
                                root="/binder-audit/list">
                            <slot slot="cardTableHeaderActions">
                                <b-link @click="binderAuditOnClickAdd" href="#" class="card-header-action btn-setting">
                                    <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Modification')}}
                                </b-link>
                            </slot>
                        </DynamicCardList>
                    </b-col>
                </b-row>
            </slot>
        </Request>

        <ModalTrash
                ref="modalTrashBinderIndex"
                root="/binder-index"
                @onTrashSuccess="binderIndexOnTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'index')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet index?')"></ModalTrash>
        <ModalTrash
                ref="modalTrashBinderForm"
                root="/binder-form"
                @onTrashSuccess="binderFormOnTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du formulaire')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce formulaire?')"></ModalTrash>
        <ModalTrash
                ref="modalTrashBinderAudit"
                root="/binder-audit"
                @onTrashSuccess="binderAuditOnTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la modification')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette modification?')"></ModalTrash>

        <ModalConfirm
                ref="modalTrashBinderIndexes"
                :closeOnConfirm="false"
                @onConfirm="onConfirmTrashIndexes"
                :caption="Core.Definition.getDefinition('Suppression des indexes')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer les indexes sélectionnés?')"></ModalConfirm>

        <ModalConfirm
                ref="modalTrashBinderForms"
                :closeOnConfirm="false"
                @onConfirm="onConfirmTrashForms"
                :caption="Core.Definition.getDefinition('Suppression des formulaires')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer les formulaires sélectionnés?')"></ModalConfirm>

        <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Déplacer vers ...')" :hide-footer="true" v-model="dataMoveBinderIndex.show">

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Enregistrement')">
                <v-select
                        ref="records"
                        @search="loadRecords"
                        v-model="dataRecord"
                        :options="dataRecordOptions"
                        :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-button :disabled="dataWaiting" class="btn" @click="binderIndexMoveTo"><i v-if="dataWaiting" class="fa fa-spin fa-spinner"></i> {{Core.Definition.getDefinition('Déplacer')}}</b-button>

        </b-modal>

        <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Dupliquer vers ...')" :hide-footer="true" v-model="dataDuplicateBinderIndex.show">

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Enregistrement')">
                <v-select
                        ref="records"
                        @search="loadRecords"
                        v-model="dataRecord"
                        :options="dataRecordOptions"
                        :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-button :disabled="dataWaiting" class="btn" @click="binderIndexDuplicateTo"><i v-if="dataWaiting" class="fa fa-spin fa-spinner"></i> {{Core.Definition.getDefinition('Dupliquer')}}</b-button>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Déplacer vers ...')" :hide-footer="true" v-model="dataMoveBinderForm.show">

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Enregistrement')">
                <v-select
                        ref="records"
                        @search="loadRecords"
                        v-model="dataRecord"
                        :options="dataRecordOptions"
                          :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Index')">
                <v-select
                        :options="dataRecordIndexOptions"
                        v-model="dataRecordIndex"
                          :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-button :disabled="dataWaiting" class="btn" @click="binderFormMoveTo"><i v-if="dataWaiting" class="fa fa-spin fa-spinner"></i> {{Core.Definition.getDefinition('Déplacer')}}</b-button>

        </b-modal>

        <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Dupliquer vers ...')" :hide-footer="true" v-model="dataDuplicateBinderForm.show">

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Enregistrement')">
                <v-select
                        ref="records"
                        @search="loadRecords"
                        v-model="dataRecord"
                        :options="dataRecordOptions"
                        :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Index')">
                <v-select
                        :options="dataRecordIndexOptions"
                        v-model="dataRecordIndex"
                        :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-button :disabled="dataWaiting" class="btn" @click="binderFormDuplicateTo"><i v-if="dataWaiting" class="fa fa-spin fa-spinner"></i> {{Core.Definition.getDefinition('Dupliquer')}}</b-button>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Dupliquer vers ...')" :hide-footer="true" v-model="dataDuplicateBinderForm.show">

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Enregistrement')">
                <v-select
                        ref="records"
                        @search="loadRecords"
                        v-model="dataRecord"
                        :options="dataRecordOptions"
                        :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-form-group
                    class="c-select"
                    :label="Core.Definition.getDefinition('Index')">
                <v-select
                        :options="dataRecordIndexOptions"
                        v-model="dataRecordIndex"
                        :multiple="false">
                    <span slot="no-options">{{Core.Definition.getDefinition('Aucune option disponible')}}</span>
                </v-select>
            </b-form-group>

            <b-button :disabled="dataWaiting" class="btn" @click="binderFormDuplicateTo"><i v-if="dataWaiting" class="fa fa-spin fa-spinner"></i> {{Core.Definition.getDefinition('Dupliquer')}}</b-button>
        </b-modal>

        <ModalFormTemplate ref="modalFormTemplate"></ModalFormTemplate>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Request from '../../../components/Request'
    import DynamicList from '../../../components/DynamicList'
    import DynamicCardList from '../../../components/DynamicCardList'
    import ModalTrash from '../../../components/ModalTrash'
    import ModalConfirm from '../../../components/ModalConfirm'
    import ModalBinderIndex from '../../../components/ModalBinderIndex'
    import ModalBinderForm from '../../../components/ModalBinderForm'
    import ModalBinderAudit from '../../../components/ModalBinderAudit'
    import ModalFormTemplate from '../../../components/ModalFormTemplate'
    import vSelect from 'vue-select'
    export default {
        name: 'BinderPanel',
        components: {
            Request,
            DynamicList,
            DynamicCardList,
            ModalTrash,
            ModalBinderIndex,
            ModalBinderForm,
            ModalBinderAudit,
            vSelect,
            ModalFormTemplate,
            ModalConfirm
        },
        props: {
            binderId: {
                type: Number | String,
                default: ''
            }
        },
        watch: {
            dataRecord(val) {
                this.dataRecordIndex = null
                this.dataRecordIndexOptions = val.indexes
                this.$forceUpdate()
            }
        },
        mounted() {
            if (this.$route.params !== undefined) {
                if (this.$route.params.slug !== undefined) {
                    this.dataSlug = this.$route.params.slug
                }
            }

            if (Core.Validation.isId(this.$route.params.id)) {
                this.dataBinderId = this.$route.params.id
            } else {
                if (Core.Validation.isId(this.binderId)) {
                    this.dataBinderId = this.binderId
                }
            }

            if (Core.Validation.isId(this.dataBinderId)) {
                this.request()
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataSlug: '',
                dataCheckedForms: [],
                dataCheckedIndexes: [],
                dataBinderId: '',
                dataBinder: {},
                dataBinderIndex: false,
                dataMoveBinderForm: {
                    show: false
                },
                dataDuplicateBinderForm: {
                  show:false
                },
                dataMoveBinderIndex: {
                    show: false
                },
                dataDuplicateBinderIndex: {
                    show:false
                },
                dataTrashBinderIndexes: {
                    show:false
                },
                dataTrashBinderForms: {
                    show:false
                },
                dataLoading: null,
                dataWaiting: false,
                dataRecord: null,
                dataRecordIndex: null,
                dataRecordOptions: [],
                dataRecordIndexOptions: [],
                dataDynamicCardListBinderIndex: {
                    actions: [
                        {
                            key: 'edit',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-edit"></i></button>',
                            callBack: this.binderIndexOnClickEdit
                        },
                        {
                            key: 'forms',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-files-o"></i></button>',
                            callBack: this.binderIndexOnClickForms
                        },
                        {
                            key: 'view',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-folder-open-o"></i></button>',
                            callBack: this.binderIndexOnClickFolder
                        },
                        {
                            key: 'check',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn check-index btn-sm btn-light"><i class="fa fa-check"></i></button>',
                            callBack: this.binderIndexOnCheck
                        },
                        {
                            key: 'trash',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></button>',
                            callBack: this.binderIndexOnClickTrash
                        }
                    ],
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },
                    columns: [
                        {
                            label: Core.Definition.getDefinition('Position'),
                            key: 'position',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Titre'),
                            key: 'title',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Type'),
                            key: 'indexType',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Date de création'),
                            key: 'createdDate',
                            type: 'dateTime',
                            sortable: true
                        }
                    ]
                },
                dataDynamicCardListBinderForm: {
                    actions: [
                        {
                            key: 'edit',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-edit"></i></button>',
                            callBack: this.binderFormOnClickEdit
                        },
                        {
                            key: 'folder',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-folder-open-o"></i></button>',
                            callBack: this.binderFormOnClickFolder
                        },
                        {
                            key: 'check',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn check-form btn-sm btn-light"><i class="fa fa-check"></i></button>',
                            callBack: this.binderFormOnCheck
                        },
                        {
                            key: 'trash',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></button>',
                            callBack: this.binderFormOnClickTrash
                        }
                    ],
                    searchFormStructure: {},
                    columns: [
                        {
                            label: Core.Definition.getDefinition('Position'),
                            key: 'position',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Titre'),
                            key: 'title',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Modèle'),
                            key: 'formTemplateId',
                            sortable: true,
                            type: 'select'
                        }
                    ]
                },
                dataDynamicCardListBinderAudit: {
                    actions: [
                        {
                            key: 'edit',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-edit"></i></button>',
                            callBack: this.binderAuditOnClickEdit
                        },
                        {
                            key: 'trash',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></button>',
                            callBack: this.binderAuditOnClickTrash
                        }
                    ],
                    columns: [
                        {
                            label: Core.Definition.getDefinition('Date'),
                            key: 'date',
                            type: 'dateTime',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Index'),
                            key: 'binderIndexId',
                            type: 'select',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Formulaire'),
                            key: 'binderFormId',
                            type: 'select',
                            sortable: true
                        }
                    ]
                }
            }
        },
        methods: {
            onConfirmTrashIndexes() {
                this.$refs.modalTrashBinderIndexes.disableConfirm = true
                this.dataWaiting = true

                if (this.dataBinderId) {

                    let binderIndexIds = []
                    for(let binderIndexId  in this.dataCheckedIndexes) {
                        if(this.dataCheckedIndexes[binderIndexId]==true) {
                            binderIndexIds.push(binderIndexId)
                        }
                    }
                    let args = [
                        {
                            key: 'binderId',
                            value: this.dataBinderId
                        },
                        {
                            key: 'binderIndexIds',
                            value: binderIndexIds
                        }
                    ]

                    Core.Request.request('DELETE', '/binder-index/trash-selected', args, this.onSuccessTrash)
                }
            },
            onConfirmTrashForms() {
                this.$refs.modalTrashBinderForms.disableConfirm = true
                this.dataWaiting = true


                if (this.dataBinderId) {

                    let binderFormIds = []
                    for(let binderFormId  in this.dataCheckedForms) {
                        if(this.dataCheckedForms[binderFormId]==true) {
                            binderFormIds.push(binderFormId)
                        }
                    }

                    let args = [
                        {
                            key: 'binderId',
                            value: this.dataBinderId
                        },
                        {
                            key: 'binderIndexId',
                            value: this.dataBinderIndex.id
                        },
                        {
                            key: 'binderFormIds',
                            value: binderFormIds
                        }
                    ]

                    Core.Request.request('DELETE', '/binder-form/trash-selected', args, this.onSuccessTrash)
                }
            },
            binderIndexMoveTo() {

                this.dataWaiting = true
                let record = this.dataRecord

                if (record.value !== undefined) {

                    let binderIndexIds = []
                    for(let binderIndexId  in this.dataCheckedIndexes) {
                        if(this.dataCheckedIndexes[binderIndexId]==true) {
                            binderIndexIds.push(binderIndexId)
                        }
                    }

                    let args = [
                        {
                            key: 'binderId',
                            value: record.value
                        },
                        {
                            key: 'binderIndexIds',
                            value: binderIndexIds
                        }
                    ]

                    Core.Request.request('POST', '/binder-index/move-to', args, this.onSuccessMove)
                }
            },
            binderIndexDuplicateTo() {
                this.dataWaiting = true
                let record = this.dataRecord

                if (record.value !== undefined) {

                    let binderIndexIds = []
                    for(let binderIndexId  in this.dataCheckedIndexes) {
                        if(this.dataCheckedIndexes[binderIndexId]==true) {
                            binderIndexIds.push(binderIndexId)
                        }
                    }

                    let args = [
                        {
                            key: 'binderId',
                            value: record.value
                        },
                        {
                            key: 'binderIndexIds',
                            value: binderIndexIds
                        }
                    ]

                    Core.Request.request('POST', '/binder-index/duplicate-to', args, this.onSuccessDuplicate)
                }
            },
            binderFormMoveTo() {

                this.dataWaiting = true
                let record = this.dataRecord
                let recordIndex = this.dataRecordIndex

                if (record.value !== undefined && recordIndex.value !== undefined) {

                    let binderFormIds = []
                    for(let binderFormId  in this.dataCheckedForms) {
                        if(this.dataCheckedForms[binderFormId]==true) {
                            binderFormIds.push(binderFormId)
                        }
                    }

                    let args = [
                        {
                            key: 'binderId',
                            value: record.value
                        },
                        {
                            key: 'binderIndexId',
                            value: recordIndex.value
                        },
                        {
                            key: 'binderFormIds',
                            value: binderFormIds
                        }
                    ]

                    Core.Request.request('POST', '/binder-form/move-to', args, this.onSuccessMove)
                }
            },
            binderFormDuplicateTo() {
                this.dataWaiting = true
                let record = this.dataRecord
                let recordIndex = this.dataRecordIndex

                if (record.value !== undefined && recordIndex.value !== undefined) {

                    let binderFormIds = []
                    for(let binderFormId  in this.dataCheckedForms) {
                        if(this.dataCheckedForms[binderFormId]==true) {
                            binderFormIds.push(binderFormId)
                        }
                    }

                    let args = [
                        {
                            key: 'binderId',
                            value: record.value
                        },
                        {
                            key: 'binderIndexId',
                            value: recordIndex.value
                        },
                        {
                            key: 'binderFormIds',
                            value: binderFormIds
                        }
                    ]

                    Core.Request.request('POST', '/binder-form/duplicate-to', args, this.onSuccessDuplicate)
                }
            },
            onSuccessTrash() {
                this.dataWaiting = false
                this.$refs.modalTrashBinderForms.disableConfirm = false
                this.$refs.modalTrashBinderIndexes.disableConfirm = false

                this.$refs.modalTrashBinderIndexes.open = false
                this.$refs.modalTrashBinderForms.open = false
                this.binderFormOnClickBack()
            },
            onSuccessMove(data) {
                this.dataMoveBinderForm.show = false
                this.dataMoveBinderIndex.show = false
                this.dataWaiting = false
                if (data.alert !== undefined) {

                    for(let binderFormId  in this.dataCheckedForms) {
                        if(this.dataCheckedForms[binderFormId]==true) {
                            let id = 'row' + binderFormId
                            let btnCheck = document.querySelector('#' + id + ' .check-form')
                            if (btnCheck.classList !== undefined) {
                                btnCheck.classList.remove('checked')
                            }
                        }
                    }

                    for(let binderFormId  in this.dataCheckedIndexes) {
                        if(this.dataCheckedIndexes[binderFormId]==true) {
                            let id = 'row' + binderFormId
                            let btnCheck = document.querySelector('#' + id + ' .check-index')
                            if (btnCheck.classList !== undefined) {
                                btnCheck.classList.remove('checked')
                            }
                        }
                    }

                    this.dataCheckedForms = []
                    this.dataCheckedIndexes = []
                    if (data.alert.variant === 'success') {
                        this.binderIndexOnRetrieveList()

                    }
                }
            },
            onSuccessDuplicate(data) {
                this.dataWaiting = false
                this.dataDuplicateBinderForm.show = false
                this.dataDuplicateBinderIndex.show = false
                if (data.alert !== undefined) {

                    for(let binderFormId  in this.dataCheckedForms) {
                        if(this.dataCheckedForms[binderFormId]==true) {
                            let id = 'row' + binderFormId
                            let btnCheck = document.querySelector('#' + id + ' .check-form')
                            if (btnCheck.classList !== undefined) {
                                btnCheck.classList.remove('checked')
                            }
                        }
                    }

                    for(let binderFormId  in this.dataCheckedIndexes) {
                        if(this.dataCheckedIndexes[binderFormId]==true) {
                            let id = 'row' + binderFormId
                            let btnCheck = document.querySelector('#' + id + ' .check-index')
                            if (btnCheck.classList !== undefined) {
                                btnCheck.classList.remove('checked')
                            }
                        }
                    }

                    this.dataCheckedForms = []
                    this.dataCheckedIndexes = []
                    if (data.alert.variant === 'success') {
                        this.dataDuplicate.show = false
                    }
                }
            },
            loadRecords(search, loading) {
                this.dataLoading = loading
                this.dataLoading(true)
                let args = [
                    {
                        key: 'binderTemplateId',
                        value: this.dataBinder.binderTemplateId
                    },
                    {
                        key: 'search',
                        value: search
                    }
                ]
                Core.Request.request('GET', '/binder/select', args, this.onRetrieveRecords)
            },
            onRetrieveRecords(data) {
                this.dataLoading(false)
                if (data.options !== undefined) {
                    this.dataRecordOptions = data.options
                }
                this.$forceUpdate()
                //this.$refs.records.options = this.dataRecordOptions
                this.dataLoading = null
            },
            init() {
                this.dataBinderIndex = false
                this.binderIndexOnRetrieveList()
                this.binderAuditOnRetrieveList()
            },
            request() {
                this.$refs.requestBinderTableOfContent.setMethod('GET')
                this.$refs.requestBinderTableOfContent.addArg('binderId', this.dataBinderId)
                this.$refs.requestBinderTableOfContent.request()
            },
            onRequestSuccess(data) {
                if(data.binder !== undefined) {
                    this.dataBinder = data.binder
                }
                this.binderIndexOnRetrieveList()
                this.binderAuditOnRetrieveList()
            },
            binderIndexOnClickAdd() {
                this.$refs.modalBinderIndex.binderId = this.dataBinder.id
                this.$refs.modalBinderIndex.id = ''
                this.$refs.modalBinderIndex.open = true
            },
            binderIndexOnClickEdit(value, cell, row) {
                this.$refs.modalBinderIndex.binderId = this.dataBinder.id
                this.$refs.modalBinderIndex.id = row.id
                this.$refs.modalBinderIndex.open = true
            },
            binderIndexOnClickForms(value, cell, row) {
                this.dataCheckedForms = []
                this.dataCheckedIndexes = []

                this.dataBinderIndex = {
                    id: row.id,
                    title: row.title,
                    position: row.position,
                    type: row.type
                }
            },
            binderIndexOnClickFolder(value, cell, row) {
                let binderIndexId = row.id
                this.$emit('binderIndexOnClickFolder', binderIndexId)
            },
            binderIndexOnClickTrash(value, cell, row) {
                this.$refs.modalTrashBinderIndex.open(row.id)
            },
            binderIndexOnTrashSuccess() {
                this.$refs.modalTrashBinderIndex.open = false
                this.binderIndexOnRetrieveList()
            },
            binderIndexOnRetrieveList() {
                if (this.$refs.dynamicCardListBinderIndex !== undefined) {
                    this.$refs.dynamicCardListBinderIndex.$refs.request.addArg('binderId', this.dataBinder.id)
                    this.$refs.dynamicCardListBinderIndex.$refs.request.request()
                }
            },
            binderIndexOnSaveSuccess(data) {
                this.$refs.modalBinderIndex.open = false
                this.$refs.dynamicCardListBinderIndex.retrieve()
            },
            binderFormOnClickAdd() {
                this.$refs.modalBinderForm.binderId = this.dataBinder.id
                this.$refs.modalBinderForm.binderIndexId = this.dataBinderIndex.id
                this.$refs.modalBinderForm.id = ''
                this.$refs.modalBinderForm.open = true
            },
            binderFormOnClickFolder(value, cell, row) {
                let binderIndexId = this.dataBinderIndex.id
                let binderFormId = row.id
                this.$emit('binderFormOnClickFolder', binderIndexId, binderFormId)
            },
            binderFormOnClickEdit(value, cell, row) {
                this.$refs.modalBinderForm.binderIndexId = this.dataBinderIndex.id
                this.$refs.modalBinderForm.binderId = this.dataBinder.id
                this.$refs.modalBinderForm.id = row.id
                this.$refs.modalBinderForm.open = true
            },
            binderFormOnCheck(value, cell, row) {
                let id = row.id
                id = 'row' + id
                let btnCheck = document.querySelector('#' + id + ' .check-form')
                if (btnCheck.classList !== undefined) {
                    if (btnCheck.classList.contains('checked')) {
                        this.dataCheckedForms[row.id] = false
                        btnCheck.classList.remove('checked')
                    } else {
                        this.dataCheckedForms[row.id] = true
                        btnCheck.classList.add('checked')
                    }
                }
            },
            binderFormOnClickMove(value, cell, row) {
                this.dataMoveBinderForm.show = true
            },
            binderFormOnClickDuplicate(value, cell, row) {
                this.dataDuplicateBinderForm.show = true
            },
            binderFormOnClickTrash(value, cell, row) {
                this.$refs.modalTrashBinderForm.open(row.id)
            },
            binderFormsOnClickTrash() {
                this.$refs.modalTrashBinderForms.open = true
            },
            binderIndexesOnClickTrash() {
                this.$refs.modalTrashBinderIndexes.open = true
            },
            binderFormOnTrashSuccess() {
                this.binderFormOnRetrieveList()
            },
            binderFormOnRetrieveList() {
                this.$refs.dynamicCardListBinderForm.$refs.request.addArg('binderId', this.dataBinder.id)
                this.$refs.dynamicCardListBinderForm.$refs.request.addArg('binderIndexId', this.dataBinderIndex.id)
                this.$refs.dynamicCardListBinderForm.$refs.request.request()
            },
            binderFormOnClickBack() {
                this.dataCheckedForms = []
                this.dataCheckedIndexes = []

                this.dataBinderIndex = false
                let _self = this
                Vue.nextTick()
                    .then(function () {
                        _self.$refs.dynamicCardListBinderIndex.retrieve()
                    })
            },
            binderFormOnSaveSuccess(data) {
                this.$refs.modalBinderForm.open = false
                this.$refs.dynamicCardListBinderForm.retrieve()
            },
            binderAuditOnClickAdd() {
                this.$refs.modalBinderAudit.binderId = this.dataBinder.id
                this.$refs.modalBinderAudit.id = ''
                this.$refs.modalBinderAudit.open = true
            },
            binderAuditOnClickEdit(value, cell, row) {
                this.$refs.modalBinderAudit.binderId = this.dataBinder.id
                this.$refs.modalBinderAudit.id = row.id
                this.$refs.modalBinderAudit.open = true
            },
            binderAuditOnClickTrash(value, cell, row) {
                this.$refs.modalTrashBinderAudit.open(row.id)
            },
            binderAuditOnTrashSuccess(data) {
                this.binderAuditOnRetrieveList()
            },
            binderAuditOnRetrieveList() {
                this.$refs.dynamicCardListBinderAudit.$refs.request.addArg('binderId', this.dataBinder.id)
                this.$refs.dynamicCardListBinderAudit.$refs.request.request()
            },
            binderAuditOnSaveSuccess(data) {
                this.$refs.modalBinderAudit.open = false
                this.$refs.dynamicCardListBinderAudit.retrieve()
            },
            binderIndexOnCheck(value, cell, row) {
                let id = row.id
                id = 'row' + id
                let btnCheck = document.querySelector('#' + id + ' .check-index')
                if (btnCheck.classList !== undefined) {
                    if (btnCheck.classList.contains('checked')) {
                        this.dataCheckedIndexes[row.id] = false
                        btnCheck.classList.remove('checked')
                    } else {
                        this.dataCheckedIndexes[row.id] = true
                        btnCheck.classList.add('checked')
                    }
                }
            },
            binderIndexOnClickMove(value, cell, row) {
                this.dataMoveBinderIndex.show = true
            },
            binderIndexOnClickDuplicate(value, cell, row) {
                this.dataDuplicateBinderIndex.show = true
            },
        }
    }
</script>
